import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import cn from 'classnames';
import { colors, fontSize, boxShadows } from '../../constants/styleConstants';
import StubPageSocialLinks from '../StubPageSocialLinks';
import ContactLinks from '../ContactLinks';
import { useTranslation } from '../../src/i18n';

const useStyles = makeStyles(() => ({
  contactCard: {
    display: 'flex',
    flexDirection: 'column',
    borderRadius: '8px',
    boxShadow: boxShadows.sideCard,
    border: `solid 1px ${colors.border.grey}`,
    padding: 15,
    marginBottom: 20,
  },
  title: {
    fontSize: fontSize.smallTitle,
    color: colors.grey3,
    lineHeight: 1.83,
    paddingBottom: '16px',
  },
}));

const ContactCard = ({ contacts, className, hideInfo, title, subTitle, socialLinksTitle }) => {
  const classes = useStyles();
  const { t } = useTranslation();
  return (
    <>
      {contacts.length > 0 && (
        <div className={cn(classes.root, className)}>
          {title && title}
          <div className={classes.contactCard}>
            {subTitle && <div className={classes.title}>{subTitle}</div>}
            <ContactLinks t={t} contacts={contacts} hideInfo={hideInfo} isProfileContact />
            <StubPageSocialLinks t={t} contacts={contacts} socialLinksTitle={socialLinksTitle} />
          </div>
        </div>
      )}
    </>
  );
};

ContactCard.propTypes = {
  contacts: PropTypes.array,
  className: PropTypes.string,
  hideInfo: PropTypes.bool,
  socialLinksTitle: PropTypes.string,
  subTitle: PropTypes.string,
};

export default ContactCard;
